// extracted by mini-css-extract-plugin
export default {"rightSideContainer":"issuanceComplete_rightSideContainer__9MPxH"};